import { createContext, useContext } from 'react';
import type { INewFolder } from '../hooks/useNewFolder';

export interface FolderNavContextValue {
  selectedId: string;
  expanded: Set<string>;
  renamingId: string | null;
  renameValue: string;
  renameError: string | null;
  invalidDropId: string | null;
  newFolder: INewFolder | null;
  newFolderName: string;
  newFolderError: string | null;
  onSelect: (id: string) => void;
  onToggle: (id: string) => void;
  onContextMenu: (e: React.MouseEvent, nodeId: string) => void;
  onRenameChange: (value: string) => void;
  onRenameCommit: () => void;
  onRenameCancel: () => void;
  onNewFolderChange: (value: string) => void;
  onNewFolderCommit: () => void;
  onNewFolderCancel: () => void;
}

export const FolderNavContext = createContext<FolderNavContextValue | null>(null);

export function useFolderNavContext(): FolderNavContextValue {
  const ctx = useContext(FolderNavContext);
  if (!ctx) throw new Error('useFolderNavContext must be used inside FolderNav');
  return ctx;
}
